export const SELECT_DATE = 'select_date';
export const SELECT_TIME = 'select_time';
export const SELECT_DURATION = 'select_duration';
export const SELECT_REASON = 'select_reason';
export const SELECT_EMOJI = 'select_emoji';
export const SIGNUP_START = 'signup_start';
export const SIGNUP_COMPLETE = 'signup_complete';
export const SIGNUP_ERROR = 'signup_error';
export const INSTAGRAM_LOGIN_START = 'instagram_login_start';
export const INSTAGRAM_LOGIN_COMPLETE = 'instagram_login_complete';
export const INSTAGRAM_LOGIN_ERROR = 'instagram_login_error';
export const PASSWORD_ERROR = 'password_error';
export const EMAIL_ERROR = 'email_error';
export const CLEAR_EMAIL_ERROR = 'clear_email_error';
export const CLEAR_PASSWORD_ERROR = 'clear_password_error';
export const SET_NAME = 'set_name';
export const SET_USERNAME = 'set_username';
export const UPLOAD_STARTED = 'upload_started';
export const UPLOAD_PROGRESS = 'upload_progress';
export const UPLOAD_COMPLETE = 'upload_complete';
export const UPLOAD_FAIL = 'upload_fail';
export const GET_PHOTO_SUCCESS = 'get_photo_success';
export const GET_PHOTO_PENDING = 'get_photo_pending';
export const MEDITATION_SAVING_ERROR = 'meditation_saving_error';
export const MEDITATION_SAVING_SUCCESS = 'meditation_saving_success';
export const GET_MEDITATIONS = 'get_meditations';
export const SAVE_MEDITATION_LINK = 'save_meditation_link';
export const SAVE_MEDITATION_GRADIENT = 'save_meditation_gradient';
export const GET_HOST_NAME = 'get_host_name';
export const DATA_IS_BEING_FETCHED = 'date_is_being_fetched';
export const DATA_FETCH_SUCCESS = 'data_fetch_success';
export const NOTE_BEING_SAVED = 'note_being_saved';
export const NOTE_SAVING_SUCCESS = 'note_saving_success';
export const CLEAR_SIGNUP_ERROR = 'clear_signup_error';
export const SET_MEDITATION_ID = 'set_meditation_id';
export const USER_PHOTO_SAVED = 'user_photo_saved';
export const USER_IS_LOGGED_IN = 'user_is_logged_in';
export const USER_IS_NOT_LOGGED_IN = 'user_is_not_logged_in';
export const RESET_MEDITATION_STATE = 'reset_meditation_state';
export const AVATAR_SAVE_START = 'avatar_save_start';
export const AVATAR_SAVE_COMPLETE = 'avatar_save_complete';
export const AVATAR_SAVE_FAIL = 'avatar_save_fail';
export const USER_DETAIL_SAVE_START = 'name_email_save_start';
export const USER_DETAIL_SAVE_SUCCESS = 'name_email_save_success';
export const USER_DETAIL_SAVE_ERROR = 'name_email_save_error';
export const FETCH_USER_START = 'fetch_user_start';
export const FETCH_USER_COMPLETE = 'fetch_user_complete';
export const FETCH_USER_ERROR = 'fetch_user_error';
export const SAVE_LINK_START = 'save_link_start';
export const SAVE_LINK_COMPLETE = 'save_link_complete';
export const SAVE_LINK_ERROR = 'save_link_error';
export const UPDATE_LINK_START = 'update_link_start';
export const UPDATE_LINK_COMPLETE = 'update_link_complete';
export const UPDATE_LINK_ERROR = 'update_link_error';
export const DELETE_LINK_START = 'delete_link_start';
export const DELETE_LINK_COMPLETE = 'delete_link_complete';
export const DELETE_LINK_ERROR = 'delete_link_error';
export const SET_USER_STATUS = 'set_user_status';
export const FETCH_USERNAME_START = 'fetch_username_start';
export const FETCH_USERNAME_COMPLETE = 'fetch_username_complete';
export const FETCH_USERNAME_ERROR = 'fetch_username_error';
export const USERNAME_EXISTS_ERROR = 'username_exists_error';
export const AUTH_USER = 'auth_user';
export const AUTH_ERROR = 'auth_error';



// WEBPACK FOOTER //
// ./src/constants/types.js